"use strict";

/*
*****************
VARIABLES INIT
*****************
*/

var isIE,
	mobileWidth,
	tabletWidth,
	largeWidth,
	desktopWidth,
	blockForm,
	blockModal,
	blockHero,
	blockNavigation,
	blockNavigationPanel,
	blockNavigationTab,
	blockNavigationInternal,
	blockNavigationInternalMain,
	blockVideo,
	blockNiveaux,
	blockMap,
	blockAdvisor,
	pageContact,
	pageAgence,
	pagePreparerSonVoyageSommaire;


/*
*****************
RESPONSIVE GRID
VARIABLES ASSIGN.
*****************
*/

mobileWidth = 481;
tabletWidth = 850; //769
largeWidth = 981;
desktopWidth = 1025;

/*
*****************
PAGES
VARIABLES ASSIGN.
*****************
*/

pageContact = $('.esprit--terdav.contact');
pageAgence = $('.esprit--terdav.agence');
pagePreparerSonVoyageSommaire = $('.esprit--terdav.preparer-son-voyage.sommaire');


$(function () {
	$('.lazy, [data-original]').lazyload({
		threshold: 200
	});

	/*
	*****************
	BLOCKS
	VARIABLES ASSIGN.
	*****************
	*/

	blockForm = $('.form');
	blockModal = $('.modal');
	blockHero = $('.hero-header');
	blockNavigation = $('.navigation');
	blockNavigationPanel = $('.navigation-panel');
	blockNavigationTab = $('.navigation-tab');
	blockNavigationInternal = $('.navigation-internal:not(.main-navigation)');
	blockNavigationInternalMain = $('.navigation-internal.main-navigation');
	blockVideo = $('#video');
	blockNiveaux = $('#niveaux');
	blockMap = $('#map');
	blockAdvisor = $('.advisor');

	pageContact = $('.esprit--terdav.contact');
	pageAgence = $('.esprit--terdav.agence');
	pagePreparerSonVoyageSommaire = $('.esprit--terdav.preparer-son-voyage.sommaire');

	/*
	*****************
	ALL PAGES
	COMPONENTS INIT.
	*****************
	*/

	carousel.init();
	content.init();
	form.init();
	inscription.init();

	if (blockModal.length || typeof agenceConfig != 'undefined') {
		modal.init();
	}

	if (blockNiveaux.length) {
		niveauxEsprit.init();
	}

	if (blockMap.length) {
		map.init();
	}

	if (blockVideo.length) {
		blockVideo.lightGallery();
	}

	if (blockNavigation.length) {
		navigation.init();
	}

	if (blockNavigationInternalMain.length) {
		navigationInternal.init();
	}

	if (blockNavigationPanel.length) {
		navigationPanel.init();
	}

	if (blockNavigationTab.length) {
		navigationTab.init();
	}

	if (blockAdvisor.length) {
		carousel.advisorCarousel();
	}

	blockForm.parsley();
	//eventTA.event();

	$('main select').selectric();

});

$(window).on('load', function () {

	if (!Modernizr.objectfit) {
		console.log('Object Fit is NOT supported in this browser');

		// FALLBACK OBJECT FIT IE11
		$('.image_object_fit').each(function () {

			var $container = $(this),
				imgUrl = $container.find('img').attr('data-original');
			if (!imgUrl) {
				imgUrl = $container.find('img').attr('src');
			}

			if (imgUrl) {
				$container.css('backgroundImage', 'url(' + imgUrl + ')');
			}
		});

	}

});


$(window).resize(function () {

	if (blockAdvisor.length) {
		carousel.advisorCarousel();
	}

});

$(window).scroll(function () {

	if (pageAgence.length && !isIE) {
		navigationPanel.scrollActive();
	}

});

//# sourceMappingURL=app.js.map